import { render, staticRenderFns } from "./CreateV2.vue?vue&type=template&id=3e20dd78&scoped=true&"
import script from "./js/CreateV2.js?vue&type=script&lang=js&"
export * from "./js/CreateV2.js?vue&type=script&lang=js&"
import style0 from "./CreateV2.vue?vue&type=style&index=0&id=3e20dd78&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e20dd78",
  null
  
)

export default component.exports